import { createContext, useContext, useState, ReactNode } from "react";
import { Site } from "../models/site.interface";
import useApiService from "../hooks/useApiService";

interface SiteContextType {
  site: Site | null;
  setSite: (site: any) => void;
  getSite: (id: string) => Promise<Site | null>;
  loadingSite: boolean;
}

const SiteContext = createContext<SiteContextType>({
  site: null,
  setSite: () => {},
  getSite: async (id: string) => Promise.resolve(null),
  loadingSite: false,
});

export const useSiteContext = () => useContext(SiteContext);

export const SiteProvider = ({ children }: { children: ReactNode }) => {
  const [site, setSite] = useState<Site | null>(null);

  const { loading: loadingSite, fetchData: fetchSite } = useApiService<Site>({
    fetchOnMount: false,
    url: "site-list",
    method: "GET",
    onSuccess: data => {
      setSite(data);
    },
  });

  const getSite = async (id: string): Promise<Site | null> => {
    const result = await fetchSite({
      url: `site-list/${id}`,
    });
    return result || null;
  };

  const value = {
    site,
    setSite,
    getSite,
    loadingSite,
  };

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
};
